/**
 * HolyRelicMedalOurLadyCoromoto 
 * www.santuariobasilicacoromoto.com
 * @author yadicksonvasquez@gmail.com
 * @updated 31/05/2025
 */

import React, { Component } from 'react';
import Header from './header';
import MainSlider from './mainSliders';
import Footer from './footer';
import medalla from '../img/medalla-oficial-santa-reliquia-virgen-coromoto.jpg';
import { Helmet } from "react-helmet";
import { Trans } from '@lingui/macro';

export default class HolyRelicMedalOurLadyCoromoto extends Component {

    constructor(props) {
        super(props);
        let language = this.props.language != null ? this.props.language : "es";
        let onLanguageChange = this.props.onLanguageChange != null ? this.props.onLanguageChange : null;
        if (sessionStorage.getItem('language') !== null) {
            this.state = { lang: sessionStorage.getItem('language'), eventChangeLanguage: onLanguageChange };
        }
        else {
            this.state = { lang: language, eventChangeLanguage: onLanguageChange };
        }
        this.refreshLanguage = this.refreshLanguage.bind(this);
    }

    componentDidMount() {
        if (sessionStorage.getItem('language') !== null) {
            if (this.state.eventChangeLanguage !== null && typeof this.state.eventChangeLanguage !== "undefined") {
                this.setState({ lang: sessionStorage.getItem('language') });
                sessionStorage.setItem('language', sessionStorage.getItem('language'));
                this.state.eventChangeLanguage(sessionStorage.getItem('language'));
            }
        }
    }

    refreshLanguage(value) {
        if (value !== null && value !== '') {
            this.setState({ lang: value });
        }
    }

    render() {
        let helmetComp;
        if (this.state.lang === 'es') {
            //seo 
            helmetComp = <Helmet>
                <title>Medalla Oficial Santa Reliquia Nuestra Se&ntilde;ora de Coromoto</title>
                <meta name="description" content=">Medalla Oficial Santa Reliquia Nuestra Se&ntilde;ora de Coromoto" />
                <meta name="keywords" content="medalla, virgen, coromoto" />
            </Helmet>;
        }
        else {
            //seo 
            helmetComp = <Helmet>
                <title>Official Medal of the Holy Relic of the Virgin of Coromoto</title>
                <meta name="description" content="Official Medal of the Holy Relic of the Virgin of Coromoto" />
                <meta name="keywords" content="medal, Virgin, Coromoto" />
            </Helmet>;
        }

        return (<div>
            {helmetComp}
            <Header language={this.state.lang} onLanguageChange={this.state.eventChangeLanguage} sendData={this.refreshLanguage} />
            <MainSlider />
            <div className="container">
                <div className="row">
                    <div className="col-12">&nbsp;</div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header"><h2><Trans>MedalOurLadyCoromotoPageLb</Trans></h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12" align="center">
                                        <img className="img-thumbnail" src={medalla} alt='Medalla Oficial Santa Reliquia Nuestra Señora de Coromoto' />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">&nbsp;</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">&nbsp;</div>
                </div>




            </div>
            <Footer />
        </div>);
    }

}